<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.app_client_id"
        placeholder="客户端"
        clearable
        filterable
        style="width: 220px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="appClient in appClientList"
          :label="appClient.name"
          :value="appClient.id"
          :key="appClient.id"
        />
      </el-select>
      订单时间:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <div>
      <div
        style="display: flex; flex-wrap: wrap; gap: 20px; margin-bottom: 20px"
      >
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'total_sales'">
            {{ data.total_sales || 0 }}
          </div>
          <div class="subtitle">总营业额</div>
        </el-card>
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'today_sales'">
            {{ data.today_sales || 0 }}
          </div>
          <div class="subtitle">今日营业额</div>
        </el-card>
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'yesterday_sales'">
            {{ data.yesterday_sales || 0 }}
          </div>
          <div class="subtitle">昨日营业额</div>
        </el-card>
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'same_period_up_rate'">
            {{ data.same_period_up_rate || 0 }}%
          </div>
          <div class="subtitle">今日同时段增长率</div>
        </el-card>
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'today_recharge'">
            {{ data.today_recharge || 0 }}
          </div>
          <div class="subtitle">今日充值总额</div>
        </el-card>
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'last_30_days_recharge'">
            {{ data.last_30_days_recharge || 0 }}
          </div>
          <div class="subtitle">近30日充值总额</div>
        </el-card>
        <el-card class="box-card" style="min-width: 200px">
          <div class="value" :id="'historical_recharge'">
            {{ data.historical_recharge || 0 }}
          </div>
          <div class="subtitle">历史充值</div>
        </el-card>
      </div>
    </div>
    <div class="filter-container">
      <el-row :gutter="21">
        <el-col :sm="12" :xs="24">
          <el-card shadow="hover">
            <div class="chart-header">总营业额：￥{{ totalSales }}</div>
            <ChartPostData :data="salesChart" />
          </el-card>
        </el-col>
        <el-col :sm="12" :xs="24">
          <el-card shadow="hover">
            <div class="chart-header">下单总数：{{ totalOrderNum }}</div>
            <ChartPostData :data="orderNumChart" />
          </el-card>
        </el-col>
        <el-col :sm="8" :xs="16">
          <el-card shadow="hover">
            <div class="chart-header">今日下单总额：￥{{ todaySales }}</div>
            <ChartPostData :data="todaySalesChart" />
          </el-card>
        </el-col>
        <el-col :sm="8" :xs="16">
          <el-card shadow="hover">
            <div class="chart-header">昨日下单总额：￥{{ yesterdaySales }}</div>
            <ChartPostData :data="yesterdaySalesChart" />
          </el-card>
        </el-col>
        <el-col :sm="8" :xs="16">
          <el-card shadow="hover">
            <div class="chart-header">近30天下单总额：￥{{ thirtySales }}</div>
            <ChartPostData :data="thirtySalesChart" />
          </el-card>
        </el-col>
        <el-col :sm="8" :xs="16">
          <el-card shadow="hover">
            <div class="chart-header">今日下单数量：{{ todayOrderNum }}</div>
            <ChartPostData :data="todayOrderNumChart" />
          </el-card>
        </el-col>
        <el-col :sm="8" :xs="16">
          <el-card shadow="hover">
            <div class="chart-header">
              昨日下单数量：{{ yesterdayOrderNum }}
            </div>
            <ChartPostData :data="yesterdayOrderNumChart" />
          </el-card>
        </el-col>
        <el-col :sm="8" :xs="16">
          <el-card shadow="hover">
            <div class="chart-header">近30天下单数量：{{ thirtyOrderNum }}</div>
            <ChartPostData :data="thirtyOrderNumChart" />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { CountUp } from 'countup.js'
import ChartPostData from '@/components/ChartPostData'
import moment from 'moment'

export default {
  components: { ChartPostData },
  data() {
    return {
      listQuery: {
        app_client_id: '',
      },
      data: {},
      dateArr: null,
      appClientList: [],
      refreshTimer: null,
      salesChart: null,
      orderNumChart: null,
      totalSales: 0,
      totalOrderNum: 0,
      yesterdaySalesChart: null,
      yesterdayOrderNumChart: null,
      yesterdaySales: 0,
      yesterdayOrderNum: 0,
      todaySalesChart: null,
      todayOrderNumChart: null,
      todaySales: 0,
      todayOrderNum: 0,
      thirtySalesChart: null,
      thirtyOrderNumChart: null,
      thirtySales: 0,
      thirtyOrderNum: 0,
    }
  },
  created() {
    this.getAppClientList()
    this.getDataCount()
    this.startAutoRefresh()
    this.getSalasChart()
    this.getYesterdaySalasChart()
    this.getTodaySalasChart()
    this.getThirtySalasChart()
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
  watch: {
    dateArr(newVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0] + ' 00:00:00'
        this.listQuery.end_at = newVal[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
  },
  methods: {
    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        this.getDataCount()
      }, 5000)
    },
    getSalasChart() {
      request({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.salesChart = {
          x: response.data.dates,
          y: [
            {
              name: '总营业额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.orderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '下单总数',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.totalSales = response.data.total_sales
        this.totalOrderNum = response.data.total_order_num
      })
    },
    getYesterdaySalasChart() {
      request({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: {
          app_client_id: this.listQuery.app_client_id,
          start_at: moment()
            .subtract(1, 'day')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment()
            .subtract(1, 'day')
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          type: 'hour',
        },
      }).then((response) => {
        this.yesterdaySalesChart = {
          x: response.data.dates,
          y: [
            {
              name: '昨日下单总额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.yesterdayOrderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '昨日下单数量',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.yesterdaySales = response.data.total_sales
        this.yesterdayOrderNum = response.data.total_order_num
      })
    },
    getTodaySalasChart() {
      request({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: {
          app_client_id: this.listQuery.app_client_id,
          start_at: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          type: 'hour',
        },
      }).then((response) => {
        this.todaySalesChart = {
          x: response.data.dates,
          y: [
            {
              name: '今日下单总额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.todayOrderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '今日下单数量',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.todaySales = response.data.total_sales
        this.todayOrderNum = response.data.total_order_num
      })
    },
    getThirtySalasChart() {
      request({
        url: '/api/backend/dataCount/salasChart',
        method: 'get',
        params: {
          app_client_id: this.listQuery.app_client_id,
          start_at: moment()
            .subtract(29, 'day')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        },
      }).then((response) => {
        this.thirtySalesChart = {
          x: response.data.dates,
          y: [
            {
              name: '近30天下单总额',
              type: 'line',
              smooth: true,
              data: response.data.salas_chart_list,
            },
          ],
        }
        this.thirtyOrderNumChart = {
          x: response.data.dates,
          y: [
            {
              name: '近30天下单数量',
              type: 'line',
              smooth: true,
              data: response.data.order_num_chart_list,
            },
          ],
        }
        this.thirtySales = response.data.total_sales
        this.thirtyOrderNum = response.data.total_order_num
      })
    },
    getDataCount() {
      request({
        url: '/api/backend/dataCount/index',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        response.data.up_rate = response.data.up_rate * 100
        response.data.same_period_up_rate =
          response.data.same_period_up_rate * 100
        const newData = response.data

        this.animateNumber('total_sales', newData.total_sales)
        this.animateNumber('today_sales', newData.today_sales)
        this.animateNumber('yesterday_sales', newData.yesterday_sales)
        this.animateNumber('up_rate', newData.up_rate)
        this.animateNumber('same_period_up_rate', newData.same_period_up_rate)

        this.data = newData

        this.getSalasChart()
        this.getYesterdaySalasChart()
        this.getTodaySalasChart()
        this.getThirtySalasChart()
      })
    },
    animateNumber(field, newValue) {
      const dom = document.getElementById(field)
      if (!dom) return

      const current = parseFloat(this.data[field]) || 0
      const endVal = parseFloat(newValue) || 0

      const options = {
        decimalPlaces: field === 'up_rate' ? 2 : 2,
        suffix:
          field === 'up_rate' || field === 'same_period_up_rate' ? '%' : '',
      }

      const countUp = new CountUp(dom, endVal, {
        ...options,
        startVal: current,
      })
      if (!countUp.error) {
        countUp.start()
      } else {
        dom.innerText = endVal
      }
    },
    getAppClientList() {
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: {
          limit: 9999999,
        },
      }).then((response) => {
        this.appClientList = response.data.data
      })
    },
    handleFilter() {
      this.getDataCount()
      this.getSalasChart()
      this.getYesterdaySalasChart()
      this.getTodaySalasChart()
      this.getThirtySalasChart()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box-card {
  text-align: center;

  .value {
    color: #546dfe;
    font-weight: bold;
    font-size: 26px;
  }

  .subtitle {
    font-size: 12px;
    color: gray;
    margin-top: 6px;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-bottom: 20px;
}

::v-deep .el-date-editor .el-range-separator {
  width: 8%;
}
.chart-header {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
